function buildOrderBy(selectedOrder) {
  console.log(selectedOrder);
  // let orderByString = ["Importance asc"];
  let orderByString = [""];

  switch (selectedOrder) {
    case 0:
      // code block
      // orderByString = ["Importance asc"];
      orderByString = [""];
      break;
    case 1:
      // code block
      orderByString = ["GlobalPrice desc"];
      break;
    case 2:
      // code block
      orderByString = ["GlobalPrice asc"];
      break;
    default:
    // code block
  }
  return orderByString;
}

export default buildOrderBy;
